const COLOR_PALETTE = [
  "#D32F2F",
  "#C62828",
  "#B71C1C",
  "#388E3C",
  "#2E7D32",
  "#1B5E20",
  "#1976D2",
  "#1565C0",
  "#0D47A1",
  "#512DA8",
  "#4527A0",
  "#311B92",
  "#00796B",
  "#00695C",
  "#004D40",
  "#F57C00",
  "#EF6C00",
  "#E65100",
  "#5D4037",
  "#4E342E",
  "#3E2723",
  "#455A64",
  "#37474F",
  "#263238",
  "#C2185B",
  "#AD1457",
  "#880E4F",
  "#AFB42B",
  "#9E9D24",
  "#689F38",
  "#558B2F",
  "#33691E",
];

function hashStringToInt(str: string): number {
  let hash = 5381; // djb2 hash initial value
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33) ^ str.charCodeAt(i); // djb2 hash algorithm
  }
  return Math.abs(hash);
}

export function getUserColor(userId: string, userName: string): string {
  const combined = `${userId}:${userName}`;
  const hash = hashStringToInt(combined);

  const index = hash % COLOR_PALETTE.length;
  return COLOR_PALETTE[index];
}
